import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback, useEffect } from 'react';
import { alarmApi } from '../services/api';
import websocketService from '../services/websocket';
import logger from '../utils/logger';

export const alarmKeys = {
  all: ['alarms'] as const,
  active: (orgId: string) => ['alarms', 'active', orgId] as const,
};

export function useActiveAlarmsCount(orgId: string | undefined) {
  const queryClient = useQueryClient();

  // Subscribe to WebSocket alarm events and invalidate
  useEffect(() => {
    const handleAlarmEvent = () => {
      logger.log('📢 Alarm event received, refreshing badge count');
      queryClient.invalidateQueries({ queryKey: alarmKeys.all });
    };

    const unsubscribe = websocketService.subscribe('alarm', handleAlarmEvent);
    return () => {
      unsubscribe();
    };
  }, [queryClient]);

  return useQuery({
    queryKey: alarmKeys.active(orgId!),
    queryFn: async () => {
      const alarms = await alarmApi.getActiveAlarms(orgId!);
      return Array.isArray(alarms) ? alarms.length : 0;
    },
    enabled: !!orgId,
    refetchInterval: 30_000,
    staleTime: 15_000,
  });
}
